import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ApiPartnerService } from '../../api/api-partner.service';

@Component({
  selector: 'app-viewuser',
  templateUrl: './viewuser.component.html',
  styleUrls: ['./viewuser.component.css']
})
export class ViewuserComponent implements OnInit {

  ViewSTB: any = {};
  actionHistory: any = [];
  listservices: any = [];
  constructor(
	  private route: ActivatedRoute,
	  private router: Router,
	  public partnerService: ApiPartnerService
  ) { }

  ngOnInit() {
  	let id = this.route.snapshot.paramMap.get('id');
  	//alert(id);
  	this.loadCustomer(id);

  }

  loadCustomer(id: any) {
    return this.partnerService.GetViewStb(id).subscribe((output: any) => {
    console.log(output);
       this.ViewSTB = output.data;
       this.listservices = output.data.services;
       this.actionHistory = output.data.customer.actionHistory;
    })
  }

}
